import { ApiError } from 'services/restService';
import { mergeStyleSets } from '@fluentui/react';
import { upToBigScreenSelector, upToLargeScreenSelector, upTosmallScreenSelector, orientationLandscape } from 'utils/breakpoints';

export interface StepRef {
	validateStep: () => Promise<boolean>
	getDatafromStep: () => Promise<any>
}

export interface StepBaseProps {
	goToNextStep: () => void,
	checkCanGoNext: (can: boolean) => void,
	stepRef: React.MutableRefObject<StepRef>,
	error?: ApiError,
	resetErrors?: () => void;
	setStepError?: (error?: ApiError) => void,
}

export interface ProcessInfo {
	id?: string,
	url?: string
}

export interface ConfigurationInfo {
	organizationId?: string,
	subscriptionId?: string,
	resourceGroupId?: string,
}

export interface Step {
	name: string,
	summary: Array<string>,
	hasError: boolean,
	ariaDescription: string
}

export interface BaseState {
	steps: Step[],
	stepIndex: number,
	canGoNext: boolean,
	error: ApiError,
	accNotification: string,
}

export const style = mergeStyleSets({
	stepShell: {
		display: 'flex',
		flexGrow: 1,
		flexDirection: 'column',
		zIndex: 1
	}
});

export const wizardStyle = {
	stepBody: {
		flexBasis: 'auto',
		overflowY: 'auto',
		selectors: {
			[orientationLandscape(upTosmallScreenSelector)]: {
				overflowY: 'initial',
			}
		}
	}
};

export const progressStyle = {
	root: {
		minWidth: '280px',
		selectors: {
			[upToLargeScreenSelector]: {
				minWidth: '210px'
			}
		}
	}
};

export const footerStyle = {
	root: {
		padding: '0 2rem',
		maxHeight: '4rem',
		width: '100%',
		'& button:not(:last-child)': {
			marginRight: '0.5rem',
		},
		selectors: {
			[upToBigScreenSelector]: {
				flex: '0 0 4rem'
			}
		}
	}
};
